import { cn } from "@/modern/utils";
import type { ReactNode } from "react";

interface EditorSectionProps {
  withDivider?: boolean;
  className?: string;
  children: ReactNode;
  dividerClassName?: string;
}

export function EditorSection({ withDivider, className, children, dividerClassName }: EditorSectionProps) {
  return (
    <>
      {withDivider && <div className={cn("border-t border-border/50", dividerClassName)} />}
      <section className={cn("space-y-5", className)}>{children}</section>
    </>
  );
}
